var React = require('react');

function ErrorFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.538 1.466a5.004 5.004 0 00-7.076 0L1.466 20.462a5.004 5.004 0 000 7.076l18.996 18.996a5.004 5.004 0 007.076 0l18.996-18.996a5.004 5.004 0 000-7.076L27.538 1.466zm-5.04 10.527a1.501 1.501 0 113.002 0v15.01a1.501 1.501 0 11-3.002 0v-15.01zm3.755 21.766a2.255 2.255 0 11-4.51 0 2.255 2.255 0 014.51 0z"}));
}

ErrorFilled.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ErrorFilled;

ErrorFilled.default = ErrorFilled;
